export const MISSIONS_STATE_TRANSITION_DURATION = 3000; // ms
export const MISSIONS_STATE_TRANSITION_DELAY = 500; // ms
